import { Injectable } from '@angular/core';
import { parseData } from '@ups/xplat/utils';
import {
  ProspectModel,
  TradeClassDto,
  TradeGroupDto,
} from '@ups/xplat/api/dto';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MyHttpClientFactory, environment } from '@ups/xplat/core';

const GET_TRADE_GROUPS = '/api/classManagement/tradeGroups';
const GET_TRADE_CLASSES = '/api/classManagement/tradeClasses/all';
const CREATE_APPLICANT = '/api/applicant';
const GET_PROSPECT_POPUP = '/api/prospect/{:prospectID}';
const SAVE_PROSPECT_POPUP = '/api/prospect';

@Injectable({
  providedIn: 'root',
})
export class ProspectService {
  http: HttpClient;

  constructor(private httpFactory: MyHttpClientFactory) {
    this.http = httpFactory.createHttpClient(environment.urls.spartaAPI);
  }

  public getTradeGroups(): Promise<TradeGroupDto[]> {
    const url = GET_TRADE_GROUPS;
    return this.http.get<TradeGroupDto[]>(url).toPromise().then(parseData);
  }

  public getTradeClasses(): Promise<TradeClassDto[]> {
    const url = GET_TRADE_CLASSES;
    return this.http.get<TradeClassDto[]>(url).toPromise().then(parseData);
  }

  public createApplicantProspect(applicant: unknown): Promise<unknown> {
    const url = CREATE_APPLICANT;
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers };

    return (
      this.http
        .post(url, applicant, options)
        // .map(d=> d as ApplicantBody)
        .toPromise()
    );
  }

  public getProspectPopUp(prospectID: string): Promise<ProspectModel> {
    const url = GET_PROSPECT_POPUP.split('{:prospectID}').join(prospectID);
    return this.http
      .get(url)
      .toPromise()
      .then((data) => parseData(data) as ProspectModel);
  }

  public saveProspectPopUp(prospect: ProspectModel): Promise<unknown> {
    const url = SAVE_PROSPECT_POPUP;

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const options = { headers };

    return this.http.put(url, prospect, options).toPromise().then(parseData);
  }
}
